// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //apiUrl: 'https://localhost:44333/',
  apiUrl: 'https://apitest.kanikhelpen.be/',
  //apiUrl: 'https://api.kanikhelpen.be/',
  imageServerUrl: 'https://vrijwilligerswerk.assistonline.eu/assets/',
  appKey: '4084b308-c209-428d-9fbf-10273d2b2e38',
  captchaKey: '6LdU4iYjAAAAAGX-0hdVqxXdWB4W_8tOXgO0xWRe'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
